var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 324,
    viewBox: "0 0 174 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87856 0.620894C10.9393 0.21098 13.0607 0.21098 15.1214 0.620894L70.8733 11.7106C72.9341 12.1205 74.8939 12.9323 76.641 14.0997L123.905 45.6805C125.652 46.8479 127.152 48.3479 128.319 50.0949L159.9 97.359C161.068 99.1061 161.879 101.066 162.289 103.127L173.379 158.879C173.789 160.939 173.789 163.061 173.379 165.121L162.289 220.873C161.879 222.934 161.068 224.894 159.9 226.641L128.319 273.905C127.152 275.652 125.652 277.152 123.905 278.319L76.641 309.9C74.8939 311.068 72.9341 311.879 70.8733 312.289L15.1214 323.379C13.0607 323.789 10.9393 323.789 8.87856 323.379L-46.8733 312.289C-48.9341 311.879 -50.8939 311.068 -52.641 309.9L-99.9051 278.319C-101.652 277.152 -103.152 275.652 -104.319 273.905L-135.9 226.641C-137.068 224.894 -137.879 222.934 -138.289 220.873L-149.379 165.121C-149.789 163.061 -149.789 160.939 -149.379 158.879L-138.289 103.127C-137.879 101.066 -137.068 99.1061 -135.9 97.359L-104.319 50.0949C-103.152 48.3479 -101.652 46.8479 -99.9051 45.6805L-52.641 14.0997C-50.8939 12.9323 -48.9341 12.1205 -46.8733 11.7106L8.87856 0.620894Z",
    fill: "#8DFFAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPolygon);
export default __webpack_public_path__ + "static/media/greenPolygon.7747b929e7b0fc288323c12caf762a2d.svg";
export { ForwardRef as ReactComponent };